export default __webpack_public_path__ + "static/media/bg-image-daytime.13c049fc.jpg";